import api from './api'

export type TargetType = 'ALL' | 'ROLES' | 'TEAM' | 'USERS' | 'GEOFENCE'
export type Priority = 'NORMAL' | 'HIGH' | 'CRITICAL'

export interface NotificationDelivery {
    id: number; campaignId: number; userId: string; channel: string; status: string
    detail?: string; sentAt?: string; ackedAt?: string
}

export const notificationService = {
    registerToken: async (token: string, platform = 'WEB') => {
        await api.post('/api/v1/notifications/token', { token, platform })
    },
    send: async (req: { title: string; body?: string; targetType: TargetType; targetSpec?: string; priority?: Priority }) =>
        (await api.post('/api/v1/notifications/campaigns', req)).data,
    myDeliveries: async (): Promise<NotificationDelivery[]> =>
        (await api.get<NotificationDelivery[]>('/api/v1/notifications/me')).data,
    ack: async (id: number) => { await api.post(`/api/v1/notifications/deliveries/${id}/ack`) },
}
